import keys from '@debbie/common/dist/cache/keys.js';
import { ParkingLotRemarkType, } from '@debbie/common/dist/parking/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as parkingAPI from '@debbie/cortex/dist/api/parking.js';
import { h } from '@debbie/cortex/dist/index.js';
import { parkingLotRemarksEntity, useParkingLotRemarks, } from '@debbie/cortex/dist/parking/index.js';
import q from '@debbie/cortex/dist/query.js';
import moment from 'moment';
import React, { useState } from 'react';
import { styled } from 'styled-components';
import Button from '../Button.js';
import DateInput from '../DateInput.js';
import { Edit } from '../Icons/index.js';
import Input from '../Input.js';
import Modal from '../Modal.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import PowerTable, { FilterType } from '../PowerTable.js';
const ParkingLotRemarks = (props) => {
    const { parkingLotReferenceId } = props;
    const parkingLotRemarksLoadable = useParkingLotRemarks(parkingLotReferenceId);
    const parkingLotRemarks = h.isLoaded(parkingLotRemarksLoadable)
        ? parkingLotRemarksLoadable.data
        : null;
    const [editRemark, setEditRemark] = useState(null);
    const saveRemark = useMutation((remark) => parkingAPI.patchParkingLotRemark(remark.parkingLotRemarkId, {
        comment: remark.comment,
        validTo: remark.validTo,
    }), {
        onSuccess: (_data, remark) => {
            q.invalidate(keys.write.modify(parkingLotRemarksEntity, remark.parkingLotRemarkId));
            setEditRemark(null);
        },
        onError: () => {
            alert('Error');
        },
    });
    const deleteRemark = useMutation((remark) => parkingAPI.deleteParkingLotRemark(remark.parkingLotRemarkId), {
        onSuccess: (_data, remark) => {
            q.invalidate(keys.write.modify(parkingLotRemarksEntity, remark.parkingLotRemarkId));
            setEditRemark(null);
        },
        onError: () => {
            alert('Error');
        },
    });
    console.log({ parkingLotRemarks });
    const valid = (date) => {
        return !date || moment(date).isAfter(moment());
    };
    return (React.createElement(React.Fragment, null,
        editRemark && (React.createElement(Modal, { header: "Rediger eller slet bem\u00E6rkning", maxWidth: "600px", onToggle: () => setEditRemark(null) },
            React.createElement(Input, { placeholder: "Kommentar", value: editRemark.comment, onChange: (e) => setEditRemark({
                    ...editRemark,
                    comment: e.target.value,
                }) }),
            React.createElement(DateInput, { placeholder: 'Gyldig til', showTimeSelect: true, onChange: (date) => setEditRemark({
                    ...editRemark,
                    validTo: date?.format() || null,
                }), value: editRemark.validTo ? moment(editRemark.validTo) : null, allowNull: true }),
            React.createElement(Button, { onClick: () => saveRemark.mutate(editRemark), loading: saveRemark.isLoading, block: true, theme: "secondary", style: { marginTop: '10px' } }, "Gem"),
            React.createElement(Button, { theme: "dangerous", onClick: () => deleteRemark.mutate(editRemark), loading: deleteRemark.isLoading, block: true, style: { marginTop: '10px' } }, "Slet bem\u00E6rkning til pladsen"))),
        parkingLotRemarks && (React.createElement(Wrapper, null, React.createElement(PowerTable, { data: parkingLotRemarks, genKey: (dpt) => JSON.stringify(dpt), pagination: {
                type: 'none',
                pageSize: parkingLotRemarks.length,
            }, values: {
                createdAt: {
                    label: 'Oprettet',
                    toCmp: (createdAt) => createdAt,
                    width: '100px',
                    map: (startingDate, row) => {
                        return (React.createElement("div", { style: { opacity: valid(row.validTo) ? 1 : 0.5 } },
                            React.createElement(Edit, { style: { cursor: 'pointer' }, onClick: () => setEditRemark(row) }),
                            ' ',
                            moment(startingDate).format('DD/MM/YYYY HH:mm')));
                    },
                    filter: {
                        type: FilterType.DateRange,
                    },
                },
                comment: {
                    label: 'Kommentar',
                    toCmp: (comment) => comment,
                    map: (comment, row) => {
                        return (React.createElement("div", { style: { opacity: valid(row.validTo) ? 1 : 0.5 } }, comment));
                    },
                },
                validTo: {
                    label: 'Gyldig til',
                    toCmp: (validTo) => validTo || '-',
                    map: (validTo) => {
                        return (React.createElement("div", { style: { opacity: valid(validTo) ? 1 : 0.5 } }, validTo
                            ? moment(validTo).format('DD/MM/YYYY HH:mm')
                            : '-'));
                    },
                    // @ts-ignore
                    filter: {
                        type: FilterType.DateRange,
                    },
                },
                createdBy: {
                    label: 'Oprettet af',
                    toCmp: () => 0,
                    map: (performedBy) => {
                        return React.createElement(PerformedBy, { performedBy: performedBy });
                    },
                },
            }, searchable: true, toSearchStr: (dpt) => JSON.stringify(dpt), defaultSortDirection: "DESC", defaultSortKey: "createdAt" })))));
};
export default ParkingLotRemarks;
const Wrapper = styled.div `
  table td {
    padding: 0.3em;
  }
`;
export const AddParkingLotRemark = (props) => {
    const { parkingLotReferenceId } = props;
    const [type, setType] = useState(ParkingLotRemarkType.Other);
    const [comment, setComment] = useState('');
    const [validTo, setValidTo] = useState(null);
    const addRemark = useMutation(() => parkingAPI.createParkingLotRemark({
        comment,
        parkingLotReferenceId: parkingLotReferenceId,
        type,
        validTo: validTo ? validTo.format() : null,
    }), {
        onSuccess: () => {
            q.invalidate(keys.write.create(parkingLotRemarksEntity));
            props.onAdd();
        },
        onError: () => {
            alert('Error');
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, { placeholder: "Kommentar", value: comment, onChange: (e) => setComment(e.target.value) }),
        React.createElement(DateInput, { placeholder: 'Gyldig til', showTimeSelect: true, onChange: (date) => setValidTo(date), value: validTo, allowNull: true }),
        React.createElement(Button, { onClick: () => addRemark.mutate(), loading: addRemark.isLoading, block: true, disabled: !comment, theme: "secondary", style: { marginTop: '10px' } }, "Tilf\u00F8j bem\u00E6rkning til pladsen")));
};
//# sourceMappingURL=ParkingLotRemarks.js.map